<div>
    <button
        mat-raised-button
        class="returnButton"
        color="accent"
        (click)="loadBack()"
    >
        <mat-icon aria-label="Calculate">keyboard_backspace</mat-icon>
        {{ "dashboardBizzDev.returnButton.fullLabel" | translate }}
    </button>
</div>
<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{
                    "dashboardBizzDev.details.test.title.fullLabel" | translate
                }}
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-sic></app-sic>
    </mat-card-content>
</mat-card>
